module.exports = __webpack_public_path__ + "img/header-weddingRingsCrown.5c0b846.webp";